// extracted by mini-css-extract-plugin
export default {"dropzone":"rsc0V2xbLEK9xwpYnZQO","background":"hmHGCMvw_gnyjnkUpy3B","imgBox":"ZUFvGxcp6LfH6v8OqL_W","chooseFileImage":"H1m3dyJpyOiyFjdPkh6r","chooseFileText":"X2o0QlGdEnsLCyC2X97I"};